import { Monitor, Moon, Sun } from "lucide-react";
import { cn } from "@/lib/utils";
import { setTheme, useTheme, type Theme } from "@/lib/theme";

// Cycle in a predictable order so repeated taps are discoverable.
const ORDER: Theme[] = ["system", "light", "dark"];
const NEXT_LABEL: Record<Theme, string> = {
  system: "Switch to light theme",
  light: "Switch to dark theme",
  dark: "Follow system theme",
};

export function ThemeToggle({ className }: { className?: string }) {
  const theme = useTheme();
  const Icon = theme === "system" ? Monitor : theme === "light" ? Sun : Moon;

  const next = () => setTheme(ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length]);

  return (
    <button
      type="button"
      onClick={next}
      aria-label={NEXT_LABEL[theme]}
      title={NEXT_LABEL[theme]}
      className={cn(
        "inline-flex size-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-accent hover:text-foreground",
        className,
      )}
    >
      <Icon className="size-[1.15rem]" />
    </button>
  );
}
